import { jsx as _jsx } from "react/jsx-runtime";
import { useIsMounted } from '@passkeys/hooks';
import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import AnimatedDigit from './animated-digit.js';
import { cn } from '../../utils/classnames.js';
const AnimatedNumber = ({ amount, small = false }) => {
    const [width, setWidth] = useState(0);
    const [hasChanged, setHasChanged] = useState(false);
    const elementRef = useRef(null);
    const isMounted = useIsMounted();
    useEffect(() => {
        if (!elementRef.current) {
            return;
        }
        const observer = new IntersectionObserver((entries) => {
            if (!entries[0].isIntersecting) {
                return;
            }
            setWidth((previousValue) => elementRef.current?.offsetWidth ?? previousValue);
        });
        observer.observe(elementRef.current);
        return () => observer.disconnect();
    }, []);
    useEffect(() => {
        if (elementRef.current) {
            const computedWidth = parseFloat(window.getComputedStyle(elementRef.current).width);
            setWidth(computedWidth);
        }
        if (isMounted()) {
            setHasChanged(true);
        }
    }, [amount, isMounted]);
    const renderDigits = useCallback(() => {
        return amount.split('').map((digit, index, array) => {
            const key = array.length - 1 - index;
            if (isNaN(parseInt(digit))) {
                return (_jsx("span", { className: "ui-animate-slide-in-down", children: digit }, key));
            }
            return _jsx(AnimatedDigit, { value: digit, small: small }, key);
        });
    }, [amount, small]);
    const containerStyle = useMemo(() => ({
        width: hasChanged ? `${width}px` : 'auto',
    }), [hasChanged, width]);
    return (_jsx("span", { className: cn(hasChanged && 'ui-transition-[width] ui-duration-500'), style: containerStyle, children: _jsx("span", { ref: elementRef, className: "ui-flex", children: renderDigits() }) }));
};
export default AnimatedNumber;
